import type { NotifyList } from "@swivu/client-api";
import { DateTime } from "luxon";
// props need to include at least start_time, end_time, recurring_interval, repeat_count
type ReminderProps<T> = T & {
  alert_date?: string | null;
  recurring_interval: NotifyList[number]["recurring_interval"];

  repeat_count: number;
};

const getRecurringDates = <T>(reminder: ReminderProps<T>, timezone: string) => {
  const { alert_date, recurring_interval, repeat_count } = reminder;
  const dates: ReminderProps<T>[] = [];

  if (!alert_date) return dates;
  const date = DateTime.fromISO(alert_date, { zone: timezone });

  for (let i = 1; i < repeat_count; i++) {
    let nextDate: DateTime;
    switch (recurring_interval) {
      case "Daily":
        nextDate = date.plus({ days: i });
        break;
      case "Weekly":
        nextDate = date.plus({ weeks: i });
        break;
      case "Monthly":
        nextDate = date.plus({ months: i });
        break;
      case "Yearly":
        nextDate = date.plus({ years: i });
        break;
      default:
        continue;
    }
    dates.push({ ...reminder, alert_date: nextDate.toISO() });
  }

  return dates;
};

const spreadReminders = <T>(
  reminders: ReminderProps<T>[],
  timezone: string
) => {
  const result: ReminderProps<T>[] = [...reminders];
  reminders.forEach((reminder) => {
    result.push(...getRecurringDates(reminder, timezone));
  });
  return result;
};

export { spreadReminders };
